import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

const INTERCHANGEABLE_DUPLICATE_ITEMS_FLAG = 'global_interchangeable_duplicate_items';

/**
 * Whether item-bank and ordering items that show the same value are graded as interchangeable.
 * Mirrors the server flag, so a slot's mark agrees with the grade.
 */
export const useInterchangeableDuplicateItems = (): boolean =>
  useIsFeatureFlagEnabled(INTERCHANGEABLE_DUPLICATE_ITEMS_FLAG).isFeatureEnabled;

/**
 * The server's rule for "same value": equal after trimming spaces at the ends, case-sensitive.
 * An empty value matches nothing here; an item always matches itself by id.
 */
export const itemsShareValue = (a: unknown, b: unknown): boolean => {
  if (typeof a !== 'string' || typeof b !== 'string') return false;
  const trimmed = a.trim();
  return trimmed !== '' && trimmed === b.trim();
};
